'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _analytics = require('../../redux/modules/analytics');

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _react = require('react');

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SegmentTracker = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        attributionData: (0, _analytics.getAttributionData)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        recordAttributionAnalytics: _analytics.recordAttributionAnalytics
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SegmentTracker, _Component);

    function SegmentTracker() {
        (0, _classCallCheck3.default)(this, SegmentTracker);
        return (0, _possibleConstructorReturn3.default)(this, (SegmentTracker.__proto__ || (0, _getPrototypeOf2.default)(SegmentTracker)).apply(this, arguments));
    }

    (0, _createClass3.default)(SegmentTracker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.recordAttributionAnalytics(this.props.attributionData);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['attributionData']);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SegmentTracker;
}(_react.Component)) || _class);
exports.default = SegmentTracker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Segment/SegmentTracker.js
// module id = 6f2F
// module chunks = 57